import { render, staticRenderFns } from "./MenubarSearch.vue?vue&type=template&id=60e530aa&"
import script from "./MenubarSearch.vue?vue&type=script&lang=js&"
export * from "./MenubarSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports